/* Options:
Date: 2026-03-11 13:29:42
Version: 5.140
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: http://localhost:3000

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
DefaultImports: LoginCredentials from './LoginCredentials'; export * from './LoginCredentials';
*/

import LoginCredentials from './LoginCredentials'; export * from './LoginCredentials';;

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId: string;
}

export interface IHasBearerToken
{
    bearerToken: string;
}

export interface IGet
{
}

export interface IPost
{
}

export interface IHasStudyNumber
{
    studyNumber: string;
}

export interface IHasPatientId
{
    patientId?: number;
}

export interface IHasFileId
{
    id?: number;
}

export enum Role
{
    SuperUser = 1,
    Administrator = 2,
    Expert = 3,
    Doctor = 4,
    Parent = 5,
    Patient = 6,
    Reference = 7,
    AssociatedDoctor = 8,
    Researcher = 9,
}

export enum InvitationStatus
{
    Pending = 1,
    Accepted = 2,
    Rejected = 3,
    Cancelled = 4,
}

export enum AuthenticationProvider
{
    Google = 1,
    Facebook = 2,
    Twitter = 3,
    System = 4,
    Credentials = 5,
}

export class PersonAuthentication
{
    public id?: number;
    public personId?: number;
    public authenticationProvider?: AuthenticationProvider;
    public reference: string;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;

    public constructor(init?: Partial<PersonAuthentication>) { (Object as any).assign(this, init); }
}

export class PersonRole
{
    public id?: number;
    public personId?: number;
    public role?: Role;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;

    public constructor(init?: Partial<PersonRole>) { (Object as any).assign(this, init); }
}

export class Doctor
{
    public id?: number;
    public personId?: number;
    public institute: string;
    public city: string;
    public state: string;
    public postcode: string;
    public countryId?: number;
    public medicalAreaId?: number;
    public medicalAreaOther: string;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;

    public constructor(init?: Partial<Doctor>) { (Object as any).assign(this, init); }
}

export enum PatientStatus
{
    Incomplete = 1,
    Review = 2,
    Correction = 3,
    Matching = 4,
    Analysis = 5,
    Results = 6,
    Complete = 7,
    Actioned = 8,
}

export enum FileType
{
    Photo = 1,
    Consent = 2,
    Karyotype = 3,
    Genetic = 4,
}

export class File
{
    public id?: number;
    public type?: FileType;
    public fileName: string;
    public extension: string;
    public mimeType: string;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;

    public constructor(init?: Partial<File>) { (Object as any).assign(this, init); }
}

export enum FaceMatchUploadStatus
{
    Accepted = 1,
    NoFace = 2,
    Duplicate = 3,
    UploadFailed = 4,
}

export class PatientPhoto
{
    public id?: number;
    public patientId?: number;
    public imagusFaceId?: number;
    public fileId?: number;
    public years?: number;
    public months?: number;
    public photographFocusId?: number;
    public faceMatchUploadStatus?: FaceMatchUploadStatus;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;
    public temporaryFileGuid: string;
    public showForMatching: boolean;
    public inadequateQuality: boolean;
    public reference: boolean;

    public constructor(init?: Partial<PatientPhoto>) { (Object as any).assign(this, init); }
}

export class GeneticDocument
{
    public id?: number;
    public patientId?: number;
    public fileId?: number;
    public fileName: string;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;
    public temporaryFileGuid: string;

    public constructor(init?: Partial<GeneticDocument>) { (Object as any).assign(this, init); }
}

export class PatientDnaVariant
{
    public id?: number;
    public patientId?: number;
    public myVariantId: string;
    public variant: string;
    public zygosityId?: number;
    public inheritanceId?: number;
    public clinicalSignificanceId?: number;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;

    public constructor(init?: Partial<PatientDnaVariant>) { (Object as any).assign(this, init); }
}

export class PatientReference
{
    public id?: number;
    public patientId?: number;
    public researchGroupId?: number;
    public referenceNumber: string;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;

    public constructor(init?: Partial<PatientReference>) { (Object as any).assign(this, init); }
}

export class PatientRelative
{
    public id?: number;
    public patientId?: number;
    public relationshipId?: number;
    public inFaceMatchId?: number;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;

    public constructor(init?: Partial<PatientRelative>) { (Object as any).assign(this, init); }
}

export class PatientHpoTerm
{
    public id?: number;
    public patientId?: number;
    public termId: string;
    public termName: string;
    public enteredBy?: number;
    public enteredDate?: string;
    public deletedBy?: number;
    public deletedDate?: string;

    public constructor(init?: Partial<PatientHpoTerm>) { (Object as any).assign(this, init); }
}

export class PatientContact
{
    public id?: number;
    public patientId?: number;
    public personId?: number;
    public enteredDate?: string;

    public constructor(init?: Partial<PatientContact>) { (Object as any).assign(this, init); }
}

export class Invitation
{
    public id?: number;
    public personId?: number;
    public patientId?: number;
    public firstName: string;
    public lastName: string;
    public email: string;
    public countryId?: number;
    public patientFirstName: string;
    public patientLastName: string;
    public role?: Role;
    public status?: InvitationStatus;
    public reason: string;
    public guid: string;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;
    public resentBy?: number;
    public resentDate?: string;
    public phoneNumber: string;
    public invitee: Person;
    public invitor: Person;
    public patient: Patient;
    public selfinvite?: boolean;
    public registerNow?: boolean;

    public constructor(init?: Partial<Invitation>) { (Object as any).assign(this, init); }
}

export enum PatientMmeStatusType
{
    NoConsentNoMatches = 1,
    NotificationsOffNoMatches = 2,
    NotificationsOffMatches = 3,
    NotificationsOnNoMatches = 4,
    NotificationsOnMatches = 5,
}

export class PatientMmeStatus
{
    public patientId?: number;
    public mmeStatus?: PatientMmeStatusType;
    public newMatches?: boolean;

    public constructor(init?: Partial<PatientMmeStatus>) { (Object as any).assign(this, init); }
}

export class Patient
{
    public id?: number;
    public personId?: number;
    public studyNumber: string;
    public status?: PatientStatus;
    public consentParticipation?: boolean;
    public consentShareImages?: boolean;
    public consentContact?: boolean;
    public consentRetainImages?: boolean;
    public consentMatchMakerExchange?: boolean;
    public consentFileId?: number;
    public consentUploadDate?: string;
    public consentApproved?: boolean;
    public consentApprovedDate?: string;
    public middleName: string;
    public genderId?: number;
    public dateOfBirth?: string;
    public intellectualDisabilityId?: number;
    public intellectualDisabilityName: string;
    public diagnosisConfirmedId?: number;
    public clinicalDiagnosisId?: number;
    public diagnosisAgeYears?: number;
    public diagnosisAgeMonths?: number;
    public omimPhenotypeDoesNotExist?: boolean;
    public omimPhenotypeName: string;
    public mimPhenotypeNumber: string;
    public omimGeneDoesNotExist?: boolean;
    public omimGeneName: string;
    public mimGeneNumber: string;
    public secondDiagnosisId?: number;
    public secondDiagnosisOmimPhenotypeDoesNotExist?: boolean;
    public secondDiagnosisOmimPhenotypeName: string;
    public secondDiagnosisMimPhenotypeNumber: string;
    public secondDiagnosisOmimGeneDoesNotExist?: boolean;
    public secondDiagnosisOmimGeneName: string;
    public secondDiagnosisMimGeneNumber: string;
    public developmentalDelayId?: number;
    public psychometricTestingId?: number;
    public diagnosisProvisionalId?: number;
    public testingTraditionalKaryotype?: boolean;
    public testingMolecularKaryotype?: boolean;
    public testingFragileX?: boolean;
    public testingBiochemical?: boolean;
    public testingSingleGene?: boolean;
    public testingMethylationStudies?: boolean;
    public testingMitochondrial?: boolean;
    public testingGenePanel?: boolean;
    public testingExomeSequencingResultPending?: boolean;
    public testingExomeSequencing?: boolean;
    public testingGenomeSequencingResultPending?: boolean;
    public testingFunctionalStudiesPending?: boolean;
    public testingGenomeSequencing?: boolean;
    public testingOther?: boolean;
    public copyNumberVariantId?: number;
    public decipherReferenceNumber: string;
    public karyotypeFileId?: number;
    public humanPhenotypeOntology: string;
    public historyOfIntellectualDisabilityId?: number;
    public inheritanceAutosomalDominant?: boolean;
    public inheritanceAutosomalRecessive?: boolean;
    public inheritanceXLinked?: boolean;
    public inheritanceImprinting?: boolean;
    public inheritanceMitochondrial?: boolean;
    public inheritanceDenovo?: boolean;
    public inheritanceOther?: boolean;
    public visitedGeneticistId?: number;
    public parentsRelatedId?: number;
    public ivfConceptionId?: number;
    public disabilityCauseAntenatalComplication?: boolean;
    public disabilityCausePerinatalComplication?: boolean;
    public disabilityCauseInfection?: boolean;
    public disabilityCauseChronicDisease?: boolean;
    public disabilityCauseTrauma?: boolean;
    public disabilityNA?: boolean;
    public studiesAustralianSolveIdPhenotypingConsortium?: boolean;
    public studiesRna4rd?: boolean;
    public studiesPersyt?: boolean;
    public studiesAfgn?: boolean;
    public studiesUdn?: boolean;
    public studiesNswGold?: boolean;
    public studiesNA?: boolean;
    public guid: string;
    public imagusPersonId: string;
    public faceMatchDiagnosisId?: number;
    public faceMatchDiagnosisNotes: string;
    public doiReference: string;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;
    public consentFile: File;
    public mmeNotificationsEnabled: boolean;
    public photos: PatientPhoto[];
    public images: GeneticDocument[];
    public dnaVariants: PatientDnaVariant[];
    public references: PatientReference[];
    public relatives: PatientRelative[];
    public patientHpoTerms: PatientHpoTerm[];
    public contacts: PatientContact[];
    public person: Person;
    public parent: Person;
    public doctor: Person;
    public associatedDoctors: Person[];
    public doctorInvitation: Invitation;
    public parentInvitation: Invitation;
    public mmeStatus: PatientMmeStatus;
    public temporaryConsentFileGuid: string;
    public temporaryKaryotypeGuid: string;
    public associatedPatient: boolean;

    public constructor(init?: Partial<Patient>) { (Object as any).assign(this, init); }
}

export class Person
{
    public id?: number;
    public firstName: string;
    public lastName: string;
    public email: string;
    public emailPreviousVerified: string;
    public emailGuid: string;
    public emailVerified?: boolean;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;
    public phoneNumber: string;
    public apiKey: string;
    public authentications: PersonAuthentication[];
    public roles: PersonRole[];
    public doctorInformation: Doctor;
    public patientInformation: Patient;
    public childCount?: number;
    public patientCount?: number;
    public hasParent?: boolean;
    public hasDoctor?: boolean;
    public visibleToExperts?: boolean;
    public deactivated: boolean;

    public constructor(init?: Partial<Person>) { (Object as any).assign(this, init); }
}

export enum LookupType
{
    Country = "Country",
    MedicalArea = "MedicalArea",
    ClinicalSignificance = "ClinicalSignificance",
    CopyNumberVariant = "CopyNumberVariant",
    DevelopmentalDelay = "DevelopmentalDelay",
    DiagnosisConfirmed = "DiagnosisConfirmed",
    ClinicalDiagnosis = "ClinicalDiagnosis",
    SecondDiagnosis = "SecondDiagnosis",
    DiagnosisProvisional = "DiagnosisProvisional",
    FaceMatchDiagnosis = "FaceMatchDiagnosis",
    Gender = "Gender",
    HistoryOfIntellectualDisability = "HistoryOfIntellectualDisability",
    Inheritance = "Inheritance",
    IntellectualDisability = "IntellectualDisability",
    IvfConception = "IvfConception",
    Relationship = "Relationship",
    ResearchGroup = "ResearchGroup",
    InFaceMatch = "InFaceMatch",
    ParentsRelated = "ParentsRelated",
    PhotographFocus = "PhotographFocus",
    PsychometricTesting = "PsychometricTesting",
    VisitedGeneticist = "VisitedGeneticist",
    Zygosity = "Zygosity",
}

export class TableFilter
{
    public propertyName: string;
    public value: Object;

    public constructor(init?: Partial<TableFilter>) { (Object as any).assign(this, init); }
}

export enum TableSortOrder
{
    Ascending = 1,
    Descending = 2,
}

export class TableSort
{
    public propertyName: string;
    public sortOrder?: TableSortOrder;

    public constructor(init?: Partial<TableSort>) { (Object as any).assign(this, init); }
}

export enum MmeTransactionType
{
    Client = 1,
    Server = 2,
}

export class PhenotypicFeature
{
    public id: string;
    public label: string;

    public constructor(init?: Partial<PhenotypicFeature>) { (Object as any).assign(this, init); }
}

export class GenomicFeature
{
    public id: string;
    public geneName: string;

    public constructor(init?: Partial<GenomicFeature>) { (Object as any).assign(this, init); }
}

export class MmeMatch
{
    public matchId?: number;
    public facematchStudyNumber: string;
    public remoteSite: string;
    public requestType: MmeTransactionType;
    public numberOfMatches?: number;
    public dateTime?: string;
    public remotePatient: string;
    public score?: number;
    public remoteDoctorName: string;
    public remoteDoctorContactHref: string;
    public phenotypicFeatures: PhenotypicFeature[];
    public genomicFeatures: GenomicFeature[];
    public mmeRequestId?: number;
    public nominatedDoctor: string;
    public viewed: boolean;

    public constructor(init?: Partial<MmeMatch>) { (Object as any).assign(this, init); }
}

export enum OmimSearchType
{
    OmimPhenotypeName = 0,
    OmimPhenotypeMimNumber = 1,
    OmimGenotypeName = 2,
    OmimGenotypeMimNumber = 3,
}

export enum OmimSearchTypeV2
{
    Phenotype = 0,
    Gene = 1,
}

export interface IHasPatient
{
    patient: Patient;
}

export class QueueAlgorithm
{
    public algorithmId: number;
    public photographs: number[];

    public constructor(init?: Partial<QueueAlgorithm>) { (Object as any).assign(this, init); }
}

export enum NotificationScheduleType
{
    Daily = 1,
    Weekly = 2,
}

export class PersonRoleMme
{
    public id?: number;
    public personRoleId?: number;
    public patientId?: number;
    public receiveMmeNotifications?: boolean;
    public notificationScheduleId?: NotificationScheduleType;
    public allowMmeContact?: boolean;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;

    public constructor(init?: Partial<PersonRoleMme>) { (Object as any).assign(this, init); }
}

export enum TemplateType
{
    ParentRegistered = 1,
    ParentDoctorRejectInvite = 2,
    ParentDoctorAcceptInvite = 3,
    ParentWelcomeAcceptInviteFromDoctor = 4,
    ParentDoctorSendInvite = 5,
    DoctorParentSendInvite = 6,
    DoctorWelcome = 7,
    DoctorCompletePatientForm = 8,
    DoctorParentRejectInvite = 9,
    DoctorParentAcceptInvite = 10,
    DoctorParentUpdatePatient = 11,
    DoctorExpertDataIssue = 12,
    ExpertDoctorSubmitPatientForm = 13,
    ExpertDoctorResubmitPatientForm = 14,
    ExpertDiagnosisAnalysisComplete = 15,
    ParentDoctorSubmitPatientForm = 16,
    ParentExpertDataIssue = 17,
    DoctorExpertEnterDiagnosis = 18,
    EmailVerification = 19,
    EnrolPatientLaterEmail = 20,
    PatientRegistrationMissingDoctor = 21,
    PasswordReset = 22,
    PasswordUpdate = 23,
    BulkPasswordSet = 24,
    ParentInviteFailureEmail = 25,
    ParentSelfSendInvite = 26,
    ExpertTemplateDiagnosedPatient = 27,
    ExpertTemplateUnDiagnosedPatient = 28,
    ParentSelfSendInviteAdmin = 29,
    AddAssociateDoctorToPatient = 30,
    DoctorTemplateUnDiagnosedPatient = 31,
    MmeMatchNotify = 32,
}

export class MailAddress
{
    public address: string;
    public displayName: string;

    public constructor(init?: Partial<MailAddress>) { (Object as any).assign(this, init); }
}

export class MailAttachment
{
    public fileName: string;
    public guid: string;

    public constructor(init?: Partial<MailAttachment>) { (Object as any).assign(this, init); }
}

export class Mail
{
    public templateType?: TemplateType;
    public subject: string;
    public body: string;
    public from: MailAddress;
    public toAddresses: MailAddress[];
    public ccAddresses: MailAddress[];
    public bccAddresses: MailAddress[];
    public attachments: MailAttachment[];

    public constructor(init?: Partial<Mail>) { (Object as any).assign(this, init); }
}

export class Algorithm
{
    public id?: number;
    public name: string;
    public description: string;
    public enabled?: boolean;
    public order?: number;
    public minSelection?: number;
    public maxSelection?: number;

    public constructor(init?: Partial<Algorithm>) { (Object as any).assign(this, init); }
}

export enum JobStatus
{
    Queued = 1,
    Processing = 2,
    PositiveDiagnosis = 3,
    NoDiagnosis = 4,
    Failure = 5,
}

export enum MatchStatus
{
    Queued = 1,
    Processing = 2,
    Complete = 3,
    Failure = 4,
}

export class MatchResult
{
    public id?: number;
    public matchId?: number;
    public patientId?: number;
    public patientPhotoId?: number;
    public order?: number;
    public distance?: number;
    public probability?: number;
    public matchScore?: number;
    public quality: string;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;
    public patient: Patient;

    public constructor(init?: Partial<MatchResult>) { (Object as any).assign(this, init); }
}

export class Match
{
    public id?: number;
    public matchBatchId?: number;
    public patientPhotoId?: number;
    public status?: MatchStatus;
    public token: string;
    public seconds?: number;
    public faceCount?: number;
    public model?: number;
    public peopleCount?: number;
    public resultCount?: number;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;
    public results: MatchResult[];

    public constructor(init?: Partial<Match>) { (Object as any).assign(this, init); }
}

export class JobMatch
{
    public id?: number;
    public jobId?: number;
    public matchId?: number;
    public match: Match;

    public constructor(init?: Partial<JobMatch>) { (Object as any).assign(this, init); }
}

export class Job
{
    public id?: number;
    public patientId?: number;
    public algorithmId?: number;
    public status?: JobStatus;
    public emailSent?: boolean;
    public score?: number;
    public result: string;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;
    public jobMatches: JobMatch[];
    public referenceCount?: number;

    public constructor(init?: Partial<Job>) { (Object as any).assign(this, init); }
}

export class JobReference
{
    public id?: number;
    public jobId?: number;
    public patientPhotoId?: number;
    public score?: number;
    public order?: number;
    public patient: Patient;

    public constructor(init?: Partial<JobReference>) { (Object as any).assign(this, init); }
}

export class SentrySettings
{
    public dsn: string;
    public application: string;
    public release: string;
    public environment: string;
    public customer: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export class ClientAppSettings
{
    public sentry: SentrySettings;

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

export class DnaVariant
{
    public aminoAcidChange: string;
    public chromosome: string;
    public cytogenetic: string;
    public dbSNP: string;
    public geneSymbol: string;
    public hgvS_c: string;
    public name: string;
    public variationID: string;

    public constructor(init?: Partial<DnaVariant>) { (Object as any).assign(this, init); }
}

export class HpoTerm
{
    public id: string;
    public name: string;
    public definition: string;

    public constructor(init?: Partial<HpoTerm>) { (Object as any).assign(this, init); }
}

export enum RecipientType
{
    To = 1,
    Cc = 2,
    Bcc = 3,
}

export class MailLogRecipient
{
    public id?: number;
    // @References("typeof(FaceMatch.ServiceModel.Types.MailLog)")
    public mailLogId?: number;

    public recipientName: string;
    public recipientEmail: string;
    public recipientType?: RecipientType;

    public constructor(init?: Partial<MailLogRecipient>) { (Object as any).assign(this, init); }
}

export class CustomField
{
    public id?: number;
    public name: string;
    public label: string;

    public constructor(init?: Partial<CustomField>) { (Object as any).assign(this, init); }
}

export class Template
{
    public id?: number;
    public name: string;
    public description: string;
    public customFields: CustomField[];

    public constructor(init?: Partial<Template>) { (Object as any).assign(this, init); }
}

export class MailLog
{
    public id?: number;
    // @References("typeof(FaceMatch.ServiceModel.Types.Template)")
    public templateId?: number;

    public subject: string;
    public body: string;
    public dateSent?: string;
    public fromName: string;
    public fromEmailAddress: string;
    public recipients: MailLogRecipient[];
    public template: Template;

    public constructor(init?: Partial<MailLog>) { (Object as any).assign(this, init); }
}

export class MmeRemoteSiteStatistics
{
    public remoteSite: string;
    public nodeId?: number;
    public transactionTypeId?: number;
    public totalTransactions?: number;
    public totalTransactionsResponded?: number;
    public totalTransactionsMatching?: number;
    public totalMatches?: number;
    public totalNewMatches?: number;
    public totalUpdateMatches?: number;
    public totalHeartbeats?: number;
    public totalHeartbeatAcks?: number;
    public totalMetrics?: number;
    public totalMetricAcks?: number;
    public totalErrors?: number;

    public constructor(init?: Partial<MmeRemoteSiteStatistics>) { (Object as any).assign(this, init); }
}

export class MmeMetrics
{
    public numberOfCases?: number;
    public numberOfSubmitters?: number;
    public numberOfGenes?: number;
    public numberOfUniqueGenes?: number;
    public numberOfVariants?: number;
    public numberOfUniqueVariants?: number;
    public numberOfFeatures?: number;
    public numberOfUniqueFeatures?: number;
    public numberOfFeatureSets?: number;
    public numberOfUniqueGenesMatched?: number;
    public numberOfCasesWithDiagnosis?: number;
    public numberOfRequestsReceived?: number;
    public numberOfPotentialMatchesSent?: number;
    public dateGenerated?: string;

    public constructor(init?: Partial<MmeMetrics>) { (Object as any).assign(this, init); }
}

export class OmimPhenotype
{
    public id?: number;
    public preferredLabel: string;
    public classID: string;
    public synonyms: string[];
    public hasRelatedGenotypes: boolean;

    public constructor(init?: Partial<OmimPhenotype>) { (Object as any).assign(this, init); }
}

export class OmimGenotype
{
    public id?: number;
    public preferredLabel: string;
    public classID: string;
    public synonyms: string[];
    public genotypeSymbols: string;

    public constructor(init?: Partial<OmimGenotype>) { (Object as any).assign(this, init); }
}

export enum MatchBatchStatus
{
    Queued = 1,
    Processing = 2,
    Complete = 3,
    Failure = 4,
}

export class MatchBatch
{
    public id?: number;
    public patientId?: number;
    public status?: MatchBatchStatus;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;
    public matches: Match[];

    public constructor(init?: Partial<MatchBatch>) { (Object as any).assign(this, init); }
}

export class Comment
{
    public id?: number;
    public patientId?: number;
    public body: string;
    public commenterId?: number;
    public enteredBy?: number;
    public enteredDate?: string;
    public modifiedBy?: number;
    public modifiedDate?: string;
    public commenter: Person;

    public constructor(init?: Partial<Comment>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

export class PersonToken
{
    public id?: number;
    public personId: number;
    public token: string;
    public dateCreated: string;

    public constructor(init?: Partial<PersonToken>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserApiKey
{
    // @DataMember(Order=1)
    public key: string;

    // @DataMember(Order=2)
    public keyType: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

export class Lookup implements ILookup
{
    public id?: number;
    public value: string;
    public rank?: number;
    public enabled?: boolean;

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}

export interface ILookup
{
    id?: number;
    value: string;
    rank?: number;
    enabled?: boolean;
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export class GetAnalysisAlgorithmsResponse
{
    public responseStatus: ResponseStatus;
    public algorithms: Algorithm[];

    public constructor(init?: Partial<GetAnalysisAlgorithmsResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientJobResponse
{
    public responseStatus: ResponseStatus;
    public job: Job;

    public constructor(init?: Partial<GetPatientJobResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientJobsResponse
{
    public responseStatus: ResponseStatus;
    public jobs: Job[];

    public constructor(init?: Partial<GetPatientJobsResponse>) { (Object as any).assign(this, init); }
}

export class QueueJobResponse
{
    public responseStatus: ResponseStatus;
    public job: Job;
    public patient: Patient;

    public constructor(init?: Partial<QueueJobResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientJobReferencesResponse
{
    public responseStatus: ResponseStatus;
    public references: JobReference[];

    public constructor(init?: Partial<GetPatientJobReferencesResponse>) { (Object as any).assign(this, init); }
}

export class GetClientAppSettingsResponse
{
    public settings: ClientAppSettings;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetClientAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class FindDnaVariantResponse
{
    public responseStatus: ResponseStatus;
    public dnaVariants: DnaVariant[];

    public constructor(init?: Partial<FindDnaVariantResponse>) { (Object as any).assign(this, init); }
}

export class FindHpoTermResponse
{
    public responseStatus: ResponseStatus;
    public hpoTerms: HpoTerm[];
    public pageCount: number;
    public totalCount: number;

    public constructor(init?: Partial<FindHpoTermResponse>) { (Object as any).assign(this, init); }
}

export class GetInvitationByGuidResponse
{
    public responseStatus: ResponseStatus;
    public invitation: Invitation;

    public constructor(init?: Partial<GetInvitationByGuidResponse>) { (Object as any).assign(this, init); }
}

export class AcceptInvitationByGuidResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AcceptInvitationByGuidResponse>) { (Object as any).assign(this, init); }
}

export class RejectInvitationByGuidResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RejectInvitationByGuidResponse>) { (Object as any).assign(this, init); }
}

export class CancelInvitationByGuidResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CancelInvitationByGuidResponse>) { (Object as any).assign(this, init); }
}

export class ResendInvitationByGuidResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ResendInvitationByGuidResponse>) { (Object as any).assign(this, init); }
}

export class SendParentInviteResponse
{
    public invitation: Invitation;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SendParentInviteResponse>) { (Object as any).assign(this, init); }
}

export class GetInvitationsByParentResponse
{
    public responseStatus: ResponseStatus;
    public invitations: Invitation[];

    public constructor(init?: Partial<GetInvitationsByParentResponse>) { (Object as any).assign(this, init); }
}

export class GetInvitationsByDoctorResponse
{
    public responseStatus: ResponseStatus;
    public invitations: Invitation[];

    public constructor(init?: Partial<GetInvitationsByDoctorResponse>) { (Object as any).assign(this, init); }
}

export class UpdateInvitationUserByGuidResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateInvitationUserByGuidResponse>) { (Object as any).assign(this, init); }
}

export class AcceptInvitationFromDoctorByGuidResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AcceptInvitationFromDoctorByGuidResponse>) { (Object as any).assign(this, init); }
}

export class GetLookupsResponse
{
    public responseStatus: ResponseStatus;
    public lookups: { [index: string]: Lookup[]; };

    public constructor(init?: Partial<GetLookupsResponse>) { (Object as any).assign(this, init); }
}

export class GetEmailsResponse
{
    public responseStatus: ResponseStatus;
    public emails: Mail[];

    public constructor(init?: Partial<GetEmailsResponse>) { (Object as any).assign(this, init); }
}

export class LoadEmailLogResponse
{
    public responseStatus: ResponseStatus;
    public emails: MailLog[];
    public resultCount?: number;

    public constructor(init?: Partial<LoadEmailLogResponse>) { (Object as any).assign(this, init); }
}

export class GetMmeMatchesByDoctorResponse
{
    public responseStatus: ResponseStatus;
    public mmeMatches: MmeMatch[];

    public constructor(init?: Partial<GetMmeMatchesByDoctorResponse>) { (Object as any).assign(this, init); }
}

export class GetMmeMatchesByExpertResponse
{
    public responseStatus: ResponseStatus;
    public mmeMatches: MmeMatch[];

    public constructor(init?: Partial<GetMmeMatchesByExpertResponse>) { (Object as any).assign(this, init); }
}

export class GetMmeRemoteSiteStatisticsResponse
{
    public responseStatus: ResponseStatus;
    public statistics: MmeRemoteSiteStatistics[];

    public constructor(init?: Partial<GetMmeRemoteSiteStatisticsResponse>) { (Object as any).assign(this, init); }
}

export class GetMmeMetricsResponse
{
    public responseStatus: ResponseStatus;
    public metrics: MmeMetrics;
    public disclaimer: string;
    public terms: string;

    public constructor(init?: Partial<GetMmeMetricsResponse>) { (Object as any).assign(this, init); }
}

export class SetMmeMatchSeenResponse
{
    public responseStatus: ResponseStatus;
    public newMatch: MmeMatch;

    public constructor(init?: Partial<SetMmeMatchSeenResponse>) { (Object as any).assign(this, init); }
}

export class HelloResponse
{
    public result: string;

    public constructor(init?: Partial<HelloResponse>) { (Object as any).assign(this, init); }
}

export class TestImagusResponse
{
    public responseStatus: ResponseStatus;
    public authenticationUrl: string;
    public json: string;
    public results: Object[];

    public constructor(init?: Partial<TestImagusResponse>) { (Object as any).assign(this, init); }
}

export class GetLastOmimCSVResponse
{
    public responseStatus: ResponseStatus;
    public fileName: string;
    public fileSizeBytes: number;
    public dateUploaded: string;

    public constructor(init?: Partial<GetLastOmimCSVResponse>) { (Object as any).assign(this, init); }
}

export class UploadOmimCSVResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UploadOmimCSVResponse>) { (Object as any).assign(this, init); }
}

export class OmimPhenotypeResponse
{
    public responseStatus: ResponseStatus;
    public phenotype: OmimPhenotype;

    public constructor(init?: Partial<OmimPhenotypeResponse>) { (Object as any).assign(this, init); }
}

export class OmimGenotypeResponse
{
    public responseStatus: ResponseStatus;
    public genotype: OmimGenotype;

    public constructor(init?: Partial<OmimGenotypeResponse>) { (Object as any).assign(this, init); }
}

export class OmimSelectionResponse
{
    public responseStatus: ResponseStatus;
    public genotype: OmimGenotype;
    public phenotype: OmimPhenotype;

    public constructor(init?: Partial<OmimSelectionResponse>) { (Object as any).assign(this, init); }
}

export class OmimAutocompleteResponse
{
    public responseStatus: ResponseStatus;
    public phenotypes: OmimPhenotype[];
    public genotypes: OmimGenotype[];
    public searchType?: OmimSearchType;
    public total?: number;

    public constructor(init?: Partial<OmimAutocompleteResponse>) { (Object as any).assign(this, init); }
}

export class OmimAutocompleteV2Response
{
    public responseStatus: ResponseStatus;
    public phenotypes: OmimPhenotype[];
    public genotypes: OmimGenotype[];
    public searchType?: OmimSearchTypeV2;
    public total?: number;

    public constructor(init?: Partial<OmimAutocompleteV2Response>) { (Object as any).assign(this, init); }
}

export class OmimValidationResponse
{
    public responseStatus: ResponseStatus;
    public isValid: boolean;

    public constructor(init?: Partial<OmimValidationResponse>) { (Object as any).assign(this, init); }
}

export class SendEnrolChildLaterResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SendEnrolChildLaterResponse>) { (Object as any).assign(this, init); }
}

export class PatientSingleByIdResponse
{
    public responseStatus: ResponseStatus;
    public patient: Patient;

    public constructor(init?: Partial<PatientSingleByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientsByParentResponse
{
    public responseStatus: ResponseStatus;
    public patients: Patient[];

    public constructor(init?: Partial<GetPatientsByParentResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientsByDoctorResponse
{
    public responseStatus: ResponseStatus;
    public patients: Patient[];

    public constructor(init?: Partial<GetPatientsByDoctorResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientsByExpertResponse
{
    public responseStatus: ResponseStatus;
    public patients: Patient[];

    public constructor(init?: Partial<GetPatientsByExpertResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientsByAssociatedDoctorResponse
{
    public responseStatus: ResponseStatus;
    public patients: Patient[];

    public constructor(init?: Partial<GetPatientsByAssociatedDoctorResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientByStudyNumberResponse
{
    public responseStatus: ResponseStatus;
    public patient: Patient;

    public constructor(init?: Partial<GetPatientByStudyNumberResponse>) { (Object as any).assign(this, init); }
}

export class UploadFaceMatchResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UploadFaceMatchResponse>) { (Object as any).assign(this, init); }
}

export class SaveAssociatedDoctorResponse
{
    public responseStatus: ResponseStatus;
    public doctor: Person;

    public constructor(init?: Partial<SaveAssociatedDoctorResponse>) { (Object as any).assign(this, init); }
}

export class SavePatientResponse
{
    public responseStatus: ResponseStatus;
    public patient: Patient;

    public constructor(init?: Partial<SavePatientResponse>) { (Object as any).assign(this, init); }
}

export class SaveReferenceResponse
{
    public responseStatus: ResponseStatus;
    public patient: Patient;

    public constructor(init?: Partial<SaveReferenceResponse>) { (Object as any).assign(this, init); }
}

export class SaveShowForMatchingResponse
{
    public responseStatus: ResponseStatus;
    public patient: Patient;

    public constructor(init?: Partial<SaveShowForMatchingResponse>) { (Object as any).assign(this, init); }
}

export class SaveInadequateQualityResponse
{
    public responseStatus: ResponseStatus;
    public patient: Patient;

    public constructor(init?: Partial<SaveInadequateQualityResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientMatchBatchesResponse
{
    public responseStatus: ResponseStatus;
    public batches: MatchBatch[];

    public constructor(init?: Partial<GetPatientMatchBatchesResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientMatchBatchResponse
{
    public responseStatus: ResponseStatus;
    public batch: MatchBatch;

    public constructor(init?: Partial<GetPatientMatchBatchResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientMatchResultsResponse
{
    public responseStatus: ResponseStatus;
    public results: MatchResult[];

    public constructor(init?: Partial<GetPatientMatchResultsResponse>) { (Object as any).assign(this, init); }
}

export class QueueMatchBatchResponse
{
    public responseStatus: ResponseStatus;
    public batch: MatchBatch;
    public patient: Patient;

    public constructor(init?: Partial<QueueMatchBatchResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientCommentsResponse
{
    public responseStatus: ResponseStatus;
    public comments: Comment[];

    public constructor(init?: Partial<GetPatientCommentsResponse>) { (Object as any).assign(this, init); }
}

export class SetStatusResponse
{
    public responseStatus: ResponseStatus;
    public patient: Patient;

    public constructor(init?: Partial<SetStatusResponse>) { (Object as any).assign(this, init); }
}

export class SetDiagnosisResponse
{
    public responseStatus: ResponseStatus;
    public patient: Patient;

    public constructor(init?: Partial<SetDiagnosisResponse>) { (Object as any).assign(this, init); }
}

export class PersonRoleMmeGetSingleResponse
{
    public responseStatus: ResponseStatus;
    public personRoleMme: PersonRoleMme;

    public constructor(init?: Partial<PersonRoleMmeGetSingleResponse>) { (Object as any).assign(this, init); }
}

export class PersonRoleMmeSaveSingleResponse
{
    public responseStatus: ResponseStatus;
    public personRoleMme: PersonRoleMme;

    public constructor(init?: Partial<PersonRoleMmeSaveSingleResponse>) { (Object as any).assign(this, init); }
}

export class GetAuthenticatedPersonResponse
{
    public responseStatus: ResponseStatus;
    public person: Person;
    public impersonation?: boolean;

    public constructor(init?: Partial<GetAuthenticatedPersonResponse>) { (Object as any).assign(this, init); }
}

export class RegisterAsParentResponse
{
    public responseStatus: ResponseStatus;
    public person: Person;
    public responseMessage: string;

    public constructor(init?: Partial<RegisterAsParentResponse>) { (Object as any).assign(this, init); }
}

export class RegisterAsDoctorResponse
{
    public responseStatus: ResponseStatus;
    public person: Person;
    public responseMessage: string;

    public constructor(init?: Partial<RegisterAsDoctorResponse>) { (Object as any).assign(this, init); }
}

export class LoadPeopleResponse
{
    public responseStatus: ResponseStatus;
    public people: Person[];
    public resultCount?: number;

    public constructor(init?: Partial<LoadPeopleResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonByIdResponse
{
    public responseStatus: ResponseStatus;
    public person: Person;

    public constructor(init?: Partial<GetPersonByIdResponse>) { (Object as any).assign(this, init); }
}

export class DeletePersonByIdResponse
{
    public responseStatus: ResponseStatus;
    public person: Person;

    public constructor(init?: Partial<DeletePersonByIdResponse>) { (Object as any).assign(this, init); }
}

export class SaveProfileResponse
{
    public responseStatus: ResponseStatus;
    public person: Person;

    public constructor(init?: Partial<SaveProfileResponse>) { (Object as any).assign(this, init); }
}

export class GetPeopleByRoleResponse
{
    public responseStatus: ResponseStatus;
    public people: Person[];

    public constructor(init?: Partial<GetPeopleByRoleResponse>) { (Object as any).assign(this, init); }
}

export class VerifyEmailByGuidResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<VerifyEmailByGuidResponse>) { (Object as any).assign(this, init); }
}

export class ResendEmailVerificationResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ResendEmailVerificationResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonTokenByIdResponse
{
    public responseStatus: ResponseStatus;
    public personToken: PersonToken;

    public constructor(init?: Partial<GetPersonTokenByIdResponse>) { (Object as any).assign(this, init); }
}

export class PostUpdatePasswordResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostUpdatePasswordResponse>) { (Object as any).assign(this, init); }
}

export class LoadPublicDoctorsResponse
{
    public responseStatus: ResponseStatus;
    public doctors: Person[];

    public constructor(init?: Partial<LoadPublicDoctorsResponse>) { (Object as any).assign(this, init); }
}

export class GetReferencePatientByStudyNumberResponse
{
    public responseStatus: ResponseStatus;
    public patient: Patient;

    public constructor(init?: Partial<GetReferencePatientByStudyNumberResponse>) { (Object as any).assign(this, init); }
}

export class SaveReferenceShowForMatchingResponse
{
    public responseStatus: ResponseStatus;
    public patient: Patient;

    public constructor(init?: Partial<SaveReferenceShowForMatchingResponse>) { (Object as any).assign(this, init); }
}

export class SaveReferenceInadequateQualityResponse
{
    public responseStatus: ResponseStatus;
    public patient: Patient;

    public constructor(init?: Partial<SaveReferenceInadequateQualityResponse>) { (Object as any).assign(this, init); }
}

export class GenerateTemplateResponse
{
    public responseStatus: ResponseStatus;
    public message: Mail;

    public constructor(init?: Partial<GenerateTemplateResponse>) { (Object as any).assign(this, init); }
}

export class GetAllTemplatesResponse
{
    public responseStatus: ResponseStatus;
    public templates: Template[];

    public constructor(init?: Partial<GetAllTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class GetCustomisableTemplatesResponse
{
    public responseStatus: ResponseStatus;
    public templates: Template[];

    public constructor(init?: Partial<GetCustomisableTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class SendGeneratedTemplateResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SendGeneratedTemplateResponse>) { (Object as any).assign(this, init); }
}

export class UploadFileResponse
{
    public responseStatus: ResponseStatus;
    public guid: string;
    public fileName: string;
    public isImage: boolean;

    public constructor(init?: Partial<UploadFileResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegisterResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public referrerUrl: string;

    // @DataMember(Order=5)
    public bearerToken: string;

    // @DataMember(Order=6)
    public refreshToken: string;

    // @DataMember(Order=7)
    public roles: string[];

    // @DataMember(Order=8)
    public permissions: string[];

    // @DataMember(Order=9)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=10)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<RegisterResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public profileUrl: string;

    // @DataMember(Order=9)
    public roles: string[];

    // @DataMember(Order=10)
    public permissions: string[];

    // @DataMember(Order=11)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=12)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @Route("/analysis/algorithm", "GET")
export class GetAnalysisAlgorithms implements IReturn<GetAnalysisAlgorithmsResponse>, IGet
{

    public constructor(init?: Partial<GetAnalysisAlgorithms>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAnalysisAlgorithms'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAnalysisAlgorithmsResponse(); }
}

// @Route("/patients/job/{StudyNumber}", "GET")
// @Route("/patients/job/{StudyNumber}/{JobId}", "GET")
export class GetPatientJob implements IReturn<GetPatientJobResponse>, IGet, IHasStudyNumber
{
    /**
    * The Study Number of the patient
    */
    // @ApiMember(DataType="string", Description="The Study Number of the patient", IsRequired=true, Name="Study Number", ParameterType="path")
    public studyNumber: string;

    /**
    * The ID of the Job
    */
    // @ApiMember(DataType="int", Description="The ID of the Job", Name="Job ID", ParameterType="path")
    public jobId?: number;

    public constructor(init?: Partial<GetPatientJob>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientJob'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientJobResponse(); }
}

// @Route("/patients/jobs/{StudyNumber}", "GET")
export class GetPatientJobs implements IReturn<GetPatientJobsResponse>, IGet, IHasStudyNumber
{
    /**
    * The Study Number of the patient
    */
    // @ApiMember(DataType="string", Description="The Study Number of the patient", IsRequired=true, Name="Study Number", ParameterType="path")
    public studyNumber: string;

    public constructor(init?: Partial<GetPatientJobs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientJobs'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientJobsResponse(); }
}

// @Route("/analysis/job", "POST")
export class QueueJob implements IReturn<QueueJobResponse>, IGet, IHasPatientId
{
    /**
    * The ID of the Patient
    */
    // @ApiMember(DataType="int", Description="The ID of the Patient", IsRequired=true, Name="Patient ID", ParameterType="body")
    public patientId: number;

    /**
    * The ID of the Algorithm
    */
    // @ApiMember(DataType="int", Description="The ID of the Algorithm", IsRequired=true, Name="Algorithm ID", ParameterType="body")
    public algorithmId: number;

    /**
    * Photographs to submit
    */
    // @ApiMember(DataType="int", Description="Photographs to submit", IsRequired=true, Name="Photographs", ParameterType="body")
    public matchIds: number[];

    public constructor(init?: Partial<QueueJob>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueJob'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueueJobResponse(); }
}

// @Route("/patients/job-reference/{StudyNumber}/{JobId}/{Limit}/{Skip}", "GET")
export class GetPatientJobReferences implements IReturn<GetPatientJobReferencesResponse>, IGet, IHasStudyNumber
{
    /**
    * The Study Number of the patient
    */
    // @ApiMember(DataType="string", Description="The Study Number of the patient", IsRequired=true, Name="Study Number", ParameterType="path")
    public studyNumber: string;

    /**
    * The ID of the Job
    */
    // @ApiMember(DataType="int", Description="The ID of the Job", IsRequired=true, Name="Job ID", ParameterType="path")
    public jobId: number;

    /**
    * Number of results to return
    */
    // @ApiMember(DataType="int", Description="Number of results to return", IsRequired=true, Name="Limit Results", ParameterType="path")
    public limit: number;

    /**
    * Number of results to skip
    */
    // @ApiMember(DataType="int", Description="Number of results to skip", IsRequired=true, Name="Skip Results", ParameterType="path")
    public skip: number;

    public constructor(init?: Partial<GetPatientJobReferences>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientJobReferences'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientJobReferencesResponse(); }
}

export class GetClientAppSettings implements IReturn<GetClientAppSettingsResponse>
{

    public constructor(init?: Partial<GetClientAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientAppSettings'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetClientAppSettingsResponse(); }
}

// @Route("/dna-variants/{Transcript}/{Variant}", "GET")
// @Route("/dna-variants", "GET")
export class FindDnaVariant implements IReturn<FindDnaVariantResponse>, IGet
{
    /**
    * Gene or Transcript to find
    */
    // @ApiMember(DataType="string", Description="Gene or Transcript to find", IsRequired=true, Name="Gene or Transcript", ParameterType="path")
    public transcript: string;

    /**
    * Number of records to return
    */
    // @ApiMember(DataType="number", Description="Number of records to return", Name="Count", ParameterType="path")
    public count?: number;

    public constructor(init?: Partial<FindDnaVariant>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FindDnaVariant'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FindDnaVariantResponse(); }
}

// @Route("/face/{Id}", "GET")
export class GetFaceImage implements IReturn<Blob>, IGet, IHasFileId
{
    /**
    * The ID of the file
    */
    // @ApiMember(DataType="integer", Description="The ID of the file", Format="int32", IsRequired=true, Name="File ID", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetFaceImage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFaceImage'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/face/search/{Id}", "GET")
export class GetSearchFaceImage implements IReturn<Blob>, IGet, IHasFileId
{
    /**
    * The ID of the file
    */
    // @ApiMember(DataType="integer", Description="The ID of the file", Format="int32", IsRequired=true, Name="File ID", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetSearchFaceImage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSearchFaceImage'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/image/{Id}", "GET")
export class GetImage implements IReturn<Blob>, IGet, IHasFileId
{
    /**
    * The ID of the file
    */
    // @ApiMember(DataType="integer", Description="The ID of the file", Format="int32", IsRequired=true, Name="File ID", ParameterType="path")
    public id: number;

    /**
    * The width at which to return the file.
    */
    // @ApiMember(DataType="integer", Description="The width at which to return the file.", Format="int32", IsRequired=true, Name="Width", ParameterType="query")
    public width: number;

    /**
    * The height at which to return the file
    */
    // @ApiMember(DataType="integer", Description="The height at which to return the file", Format="int32", IsRequired=true, Name="Height", ParameterType="query")
    public height: number;

    public constructor(init?: Partial<GetImage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetImage'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/file/{Id}", "GET")
export class GetFile implements IReturn<Blob>, IGet, IHasFileId
{
    /**
    * The ID of the file
    */
    // @ApiMember(DataType="integer", Description="The ID of the file", Format="int32", IsRequired=true, Name="File ID", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/hpo-terms/{SearchTerm}", "GET")
export class FindHpoTerms implements IReturn<FindHpoTermResponse>, IGet
{
    /**
    * Search Term for filtering Hpo Terms
    */
    // @ApiMember(DataType="string", Description="Search Term for filtering Hpo Terms", IsRequired=true, Name="SearchTerm", ParameterType="path")
    public searchTerm: string;

    public constructor(init?: Partial<FindHpoTerms>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FindHpoTerms'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FindHpoTermResponse(); }
}

// @Route("/map-hpo-terms", "GET")
export class MapHpoTerms implements IReturn<FindHpoTermResponse>, IGet
{

    public constructor(init?: Partial<MapHpoTerms>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MapHpoTerms'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FindHpoTermResponse(); }
}

// @Route("/invitation/by-guid/{Guid}", "GET")
export class GetInvitationByGuid implements IReturn<GetInvitationByGuidResponse>, IGet
{
    /**
    * The GUID of the invitation.
    */
    // @ApiMember(DataType="string", Description="The GUID of the invitation.", IsRequired=true, Name="GUID", ParameterType="path")
    public guid: string;

    public constructor(init?: Partial<GetInvitationByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvitationByGuid'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvitationByGuidResponse(); }
}

// @Route("/invitation/acccept/by-guid", "POST")
export class AcceptInvitationByGuid implements IReturn<AcceptInvitationByGuidResponse>, IPost
{
    /**
    * The GUID of the invitation.
    */
    // @ApiMember(DataType="string", Description="The GUID of the invitation.", IsRequired=true, Name="GUID", ParameterType="body")
    public guid: string;

    public constructor(init?: Partial<AcceptInvitationByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AcceptInvitationByGuid'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AcceptInvitationByGuidResponse(); }
}

// @Route("/invitation/reject/by-guid", "POST")
export class RejectInvitationByGuid implements IReturn<RejectInvitationByGuidResponse>, IPost
{
    /**
    * The GUID of the invitation.
    */
    // @ApiMember(DataType="string", Description="The GUID of the invitation.", IsRequired=true, Name="GUID", ParameterType="body")
    public guid: string;

    /**
    * The reason for rejecting the invitation.
    */
    // @ApiMember(DataType="string", Description="The reason for rejecting the invitation.", IsRequired=true, Name="Reason", ParameterType="body")
    public reason: string;

    public constructor(init?: Partial<RejectInvitationByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RejectInvitationByGuid'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RejectInvitationByGuidResponse(); }
}

// @Route("/invitation/cancel/by-guid", "POST")
export class CancelInvitationByGuid implements IReturn<CancelInvitationByGuidResponse>, IPost
{
    /**
    * The GUID of the invitation.
    */
    // @ApiMember(DataType="string", Description="The GUID of the invitation.", IsRequired=true, Name="GUID", ParameterType="body")
    public guid: string;

    /**
    * The reason for rejecting the invitation.
    */
    // @ApiMember(DataType="string", Description="The reason for rejecting the invitation.", IsRequired=true, Name="Reason", ParameterType="body")
    public reason: string;

    public constructor(init?: Partial<CancelInvitationByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelInvitationByGuid'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CancelInvitationByGuidResponse(); }
}

// @Route("/invitation/resend/by-guid", "POST")
export class ResendInvitationByGuid implements IReturn<ResendInvitationByGuidResponse>, IPost
{
    /**
    * The GUID of the invitation.
    */
    // @ApiMember(DataType="string", Description="The GUID of the invitation.", IsRequired=true, Name="GUID", ParameterType="body")
    public guid: string;

    public constructor(init?: Partial<ResendInvitationByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResendInvitationByGuid'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResendInvitationByGuidResponse(); }
}

// @Route("/invitation/send/parent", "POST")
export class SendParentInvite implements IReturn<SendParentInviteResponse>, IPost
{
    /**
    * The details of the invitation to be sent.
    */
    // @ApiMember(DataType="string", Description="The details of the invitation to be sent.", IsRequired=true, Name="Invitation", ParameterType="body")
    public invitation: Invitation;

    /**
    * The Person id for the doctor chosen by the patient
    */
    // @ApiMember(DataType="int", Description="The Person id for the doctor chosen by the patient", IsRequired=true, Name="DoctorId", ParameterType="body")
    public doctorId: string;

    /**
    * Token for checking when executing user isn't existing Facemant user
    */
    // @ApiMember(DataType="string", Description="Token for checking when executing user isn't existing Facemant user", IsRequired=true, Name="Token", ParameterType="body")
    public token: string;

    public constructor(init?: Partial<SendParentInvite>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendParentInvite'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendParentInviteResponse(); }
}

// @Route("/invitations/by-current-parent", "GET")
export class GetInvitationsByParent implements IReturn<GetInvitationsByParentResponse>, IGet
{

    public constructor(init?: Partial<GetInvitationsByParent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvitationsByParent'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvitationsByParentResponse(); }
}

// @Route("/invitations/by-current-doctor", "GET")
export class GetInvitationsByDoctor implements IReturn<GetInvitationsByDoctorResponse>, IGet
{

    public constructor(init?: Partial<GetInvitationsByDoctor>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvitationsByDoctor'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvitationsByDoctorResponse(); }
}

// @Route("/invitation/update/{guid}", "GET")
export class UpdateInvitationUserByGuid implements IReturn<UpdateInvitationUserByGuidResponse>, IGet
{

    public constructor(init?: Partial<UpdateInvitationUserByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateInvitationUserByGuid'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UpdateInvitationUserByGuidResponse(); }
}

// @Route("/invitation/acccept-parent/by-guid", "POST")
export class AcceptInvitationFromDoctorByGuid implements IReturn<AcceptInvitationFromDoctorByGuidResponse>, IPost
{
    /**
    * The GUID of the invitation.
    */
    // @ApiMember(DataType="string", Description="The GUID of the invitation.", IsRequired=true, Name="GUID", ParameterType="body")
    public guid: string;

    public constructor(init?: Partial<AcceptInvitationFromDoctorByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AcceptInvitationFromDoctorByGuid'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AcceptInvitationFromDoctorByGuidResponse(); }
}

// @Route("/lookup/{Lookups}", "GET")
export class GetLookups implements IReturn<GetLookupsResponse>, IGet
{
    /**
    * Name of the lookups to load
    */
    // @ApiMember(DataType="array", Description="Name of the lookups to load", IsRequired=true, Name="Lookups", ParameterType="path")
    public lookups: LookupType[];

    public constructor(init?: Partial<GetLookups>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLookups'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLookupsResponse(); }
}

// @Route("/Email", "GET")
export class GetEmails implements IReturn<GetEmailsResponse>, IGet
{

    public constructor(init?: Partial<GetEmails>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEmails'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetEmailsResponse(); }
}

// @Route("/emaillog")
// @Route("/emaillog/{Number}")
// @Route("/emaillog/{Number}/{Page}")
export class LoadEmailLog implements IReturn<LoadEmailLogResponse>, IPost, IGet
{
    public number?: number;
    public page?: number;
    public tableFilter: TableFilter[];
    public tableSort: TableSort[];

    public constructor(init?: Partial<LoadEmailLog>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LoadEmailLog'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LoadEmailLogResponse(); }
}

// @Route("/mme-matches/by-current-doctor", "GET")
export class GetMmeMatchesByDoctor implements IReturn<GetMmeMatchesByDoctorResponse>, IGet
{

    public constructor(init?: Partial<GetMmeMatchesByDoctor>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMmeMatchesByDoctor'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMmeMatchesByDoctorResponse(); }
}

// @Route("/mme-matches/by-current-expert", "GET")
export class GetMmeMatchesByExpert implements IReturn<GetMmeMatchesByExpertResponse>, IGet
{

    public constructor(init?: Partial<GetMmeMatchesByExpert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMmeMatchesByExpert'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMmeMatchesByExpertResponse(); }
}

// @Route("/mme-remote-sites/statistics", "GET")
export class GetMmeRemoteSiteStatistics implements IReturn<GetMmeRemoteSiteStatisticsResponse>, IGet
{

    public constructor(init?: Partial<GetMmeRemoteSiteStatistics>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMmeRemoteSiteStatistics'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMmeRemoteSiteStatisticsResponse(); }
}

// @Route("/mme-metrics", "GET")
export class GetMmeMetrics implements IReturn<GetMmeMetricsResponse>, IGet
{

    public constructor(init?: Partial<GetMmeMetrics>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMmeMetrics'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMmeMetricsResponse(); }
}

export class SetMmeMatchSeen implements IReturn<SetMmeMatchSeenResponse>, IPost
{
    public mmeMatch: MmeMatch;

    public constructor(init?: Partial<SetMmeMatchSeen>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetMmeMatchSeen'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetMmeMatchSeenResponse(); }
}

// @Route("/hello")
// @Route("/hello/{Name}")
export class Hello implements IReturn<HelloResponse>
{
    public name: string;

    public constructor(init?: Partial<Hello>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Hello'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HelloResponse(); }
}

// @Route("/imagus/test", "GET")
export class TestImagus implements IReturn<TestImagusResponse>, IGet
{

    public constructor(init?: Partial<TestImagus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TestImagus'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TestImagusResponse(); }
}

export class GetLastOmimCSV implements IReturn<GetLastOmimCSVResponse>, IPost
{

    public constructor(init?: Partial<GetLastOmimCSV>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLastOmimCSV'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetLastOmimCSVResponse(); }
}

export class UploadOmimCSV implements IReturn<UploadOmimCSVResponse>, IPost
{
    /**
    * 
    */
    // @ApiMember(DataType="string", Description="", IsRequired=true, Name="File name", ParameterType="body")
    public fileName: string;

    /**
    * File as a base64 encoded string
    */
    // @ApiMember(DataType="string", Description="File as a base64 encoded string", IsRequired=true, Name="File upload", ParameterType="body")
    public file: string;

    public constructor(init?: Partial<UploadOmimCSV>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadOmimCSV'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadOmimCSVResponse(); }
}

// @Route("/omim/phenotype", "GET")
export class OmimGetPhenotype implements IReturn<OmimPhenotypeResponse>, IGet
{
    public omimPhenotypeName: string;
    public omimPhenotypeMimNumber: string;

    public constructor(init?: Partial<OmimGetPhenotype>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OmimGetPhenotype'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OmimPhenotypeResponse(); }
}

// @Route("/omim/genotype", "GET")
export class OmimGetGenotype implements IReturn<OmimGenotypeResponse>, IGet
{
    public omimPhenotypeName: string;
    public omimPhenotypeMimNumber: string;
    public omimGenotypeName: string;
    public omimGenotypeMimNumber: string;

    public constructor(init?: Partial<OmimGetGenotype>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OmimGetGenotype'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OmimGenotypeResponse(); }
}

// @Route("/omim/genotype", "GET")
export class OmimGetSelection implements IReturn<OmimSelectionResponse>, IGet
{
    public omimPhenotypeName: string;
    public omimPhenotypeMimNumber: string;
    public omimGenotypeName: string;
    public omimGenotypeMimNumber: string;

    public constructor(init?: Partial<OmimGetSelection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OmimGetSelection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OmimSelectionResponse(); }
}

export class OmimAutocomplete implements IReturn<OmimAutocompleteResponse>, IGet
{
    /**
    * The text input from the user when doing autocomplete search
    */
    // @ApiMember(DataType="string", Description="The text input from the user when doing autocomplete search", IsRequired=true, Name="User input", ParameterType="path")
    public userInput: string;

    /**
    * The type of search to process
    */
    // @ApiMember(DataType="enum", Description="The type of search to process", IsRequired=true, Name="Search type", ParameterType="path")
    public searchType: OmimSearchType;

    /**
    * If set then return the associated phenotypes
    */
    // @ApiMember(DataType="int", Description="If set then return the associated phenotypes", Name="Genotype id", ParameterType="path")
    public genotypeId?: number;

    /**
    * If set then return the associated genotypes
    */
    // @ApiMember(DataType="int", Description="If set then return the associated genotypes", Name="Phenotype id", ParameterType="path")
    public phenotypeId?: number;

    /**
    * Used for paganation
    */
    // @ApiMember(DataType="int", Description="Used for paganation", Name="Skip", ParameterType="path")
    public skip?: number;

    /**
    * Used for paganation
    */
    // @ApiMember(DataType="int", Description="Used for paganation", Name="Take", ParameterType="path")
    public take?: number;

    public constructor(init?: Partial<OmimAutocomplete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OmimAutocomplete'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OmimAutocompleteResponse(); }
}

// @Route("/omim/autocomplete", "GET")
export class OmimAutocompleteV2 implements IReturn<OmimAutocompleteV2Response>, IGet
{
    /**
    * The text input from the user when doing autocomplete search
    */
    // @ApiMember(DataType="string", Description="The text input from the user when doing autocomplete search", IsRequired=true, Name="User input", ParameterType="path")
    public userInput: string;

    /**
    * The type of search to process
    */
    // @ApiMember(DataType="enum", Description="The type of search to process", IsRequired=true, Name="Search type", ParameterType="path")
    public searchType: OmimSearchTypeV2;

    /**
    * If set then return the associated phenotypes
    */
    // @ApiMember(DataType="int", Description="If set then return the associated phenotypes", Name="Genotype id", ParameterType="path")
    public genotypeId?: number;

    /**
    * If set then return the associated genotypes
    */
    // @ApiMember(DataType="int", Description="If set then return the associated genotypes", Name="Phenotype id", ParameterType="path")
    public phenotypeId?: number;

    /**
    * Used for paganation
    */
    // @ApiMember(DataType="int", Description="Used for paganation", Name="Skip", ParameterType="path")
    public skip?: number;

    /**
    * Used for paganation
    */
    // @ApiMember(DataType="int", Description="Used for paganation", Name="Take", ParameterType="path")
    public take?: number;

    public constructor(init?: Partial<OmimAutocompleteV2>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OmimAutocompleteV2'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OmimAutocompleteV2Response(); }
}

export class OmimValidation implements IReturn<OmimValidationResponse>, IGet
{
    /**
    * 
    */
    // @ApiMember(DataType="string", Description="", IsRequired=true, Name="Omim Phenotype Name", ParameterType="path")
    public omimPhenotypeName: string;

    /**
    * 
    */
    // @ApiMember(DataType="string", Description="", IsRequired=true, Name="Omim Gene Name", ParameterType="path")
    public omimGeneName: string;

    /**
    * 
    */
    // @ApiMember(DataType="string", Description="", IsRequired=true, Name="Omim Phenotype MIM Number", ParameterType="path")
    public omimPhenotypeMIMNumber: string;

    /**
    * 
    */
    // @ApiMember(DataType="string", Description="", IsRequired=true, Name="Omim Gene MIM Number", ParameterType="path")
    public omimGeneMIMNumber: string;

    public constructor(init?: Partial<OmimValidation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OmimValidation'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OmimValidationResponse(); }
}

// @Route("/parent/enrol-child-later", "GET")
export class SendEnrolChildLater implements IReturn<SendEnrolChildLaterResponse>, IPost
{

    public constructor(init?: Partial<SendEnrolChildLater>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendEnrolChildLater'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendEnrolChildLaterResponse(); }
}

// @Route("/patient/{PatientId}", "GET")
export class PatientSingleById implements IReturn<PatientSingleByIdResponse>, IGet
{
    /**
    * The patient id of the patient to retrieve
    */
    // @ApiMember(DataType="int", Description="The patient id of the patient to retrieve", IsRequired=true, Name="PatientId", ParameterType="path")
    public patientId: number;

    public constructor(init?: Partial<PatientSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientSingleByIdResponse(); }
}

// @Route("/patients/by-current-parent", "GET")
export class GetPatientsByParent implements IReturn<GetPatientsByParentResponse>, IGet
{

    public constructor(init?: Partial<GetPatientsByParent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientsByParent'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientsByParentResponse(); }
}

// @Route("/patients/by-current-doctor", "GET")
export class GetPatientsByDoctor implements IReturn<GetPatientsByDoctorResponse>, IGet
{

    public constructor(init?: Partial<GetPatientsByDoctor>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientsByDoctor'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientsByDoctorResponse(); }
}

// @Route("/patients/by-current-expert", "GET")
export class GetPatientsByExpert implements IReturn<GetPatientsByExpertResponse>, IGet
{

    public constructor(init?: Partial<GetPatientsByExpert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientsByExpert'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientsByExpertResponse(); }
}

// @Route("/patients/export-by-expert", "GET")
export class ExportPatientsByExpert implements IReturn<GetPatientsByExpertResponse>, IGet
{
    public expertTableFilter: string;

    public constructor(init?: Partial<ExportPatientsByExpert>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportPatientsByExpert'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientsByExpertResponse(); }
}

// @Route("/patients/by-current-associated-doctor", "GET")
export class GetPatientsByAssociatedDoctor implements IReturn<GetPatientsByAssociatedDoctorResponse>, IGet
{

    public constructor(init?: Partial<GetPatientsByAssociatedDoctor>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientsByAssociatedDoctor'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientsByAssociatedDoctorResponse(); }
}

// @Route("/patients/by-study-number/{StudyNumber}", "GET")
export class GetPatientByStudyNumber implements IReturn<GetPatientByStudyNumberResponse>, IGet, IHasStudyNumber
{
    /**
    * The study number of the patient
    */
    // @ApiMember(DataType="string", Description="The study number of the patient", IsRequired=true, Name="Study Number", ParameterType="path")
    public studyNumber: string;

    public constructor(init?: Partial<GetPatientByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientByStudyNumberResponse(); }
}

// @Route("/patients", "GET")
export class UploadFaceMatch implements IReturn<UploadFaceMatchResponse>, IGet
{

    public constructor(init?: Partial<UploadFaceMatch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadFaceMatch'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UploadFaceMatchResponse(); }
}

// @Route("/patients/save-associated-doctor", "Post")
export class SaveAssociatedDoctor implements IReturn<SaveAssociatedDoctorResponse>, IPost
{
    /**
    * Id of the doctor to add
    */
    // @ApiMember(DataType="int", Description="Id of the doctor to add", IsRequired=true, Name="DoctorId", ParameterType="body")
    public doctorId: number;

    /**
    * The id of the patient to add the doctor to
    */
    // @ApiMember(DataType="int", Description="The id of the patient to add the doctor to", IsRequired=true, Name="PatientPersonId", ParameterType="body")
    public patientPersonId: number;

    public constructor(init?: Partial<SaveAssociatedDoctor>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveAssociatedDoctor'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveAssociatedDoctorResponse(); }
}

export class RemoveAssociatedDoctor implements IReturn<SaveAssociatedDoctorResponse>, IPost
{
    /**
    * Id of the doctor to add
    */
    // @ApiMember(DataType="int", Description="Id of the doctor to add", IsRequired=true, Name="DoctorId", ParameterType="body")
    public doctorId: number;

    /**
    * The id of the patient to add the doctor to
    */
    // @ApiMember(DataType="int", Description="The id of the patient to add the doctor to", IsRequired=true, Name="PatientPersonId", ParameterType="body")
    public patientPersonId: number;

    public constructor(init?: Partial<RemoveAssociatedDoctor>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveAssociatedDoctor'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveAssociatedDoctorResponse(); }
}

// @Route("/patients/save", "Post")
export class SavePatient implements IReturn<SavePatientResponse>, IPost, IHasPatient
{
    /**
    * The patient to be saved
    */
    // @ApiMember(DataType="object", Description="The patient to be saved", IsRequired=true, Name="Patient", ParameterType="body")
    public patient: Patient;

    /**
    * A comment for the patient
    */
    // @ApiMember(DataType="string", Description="A comment for the patient", Name="Comment", ParameterType="body")
    public comment: string;

    public constructor(init?: Partial<SavePatient>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SavePatient'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SavePatientResponse(); }
}

// @Route("/patients/save-reference", "Post")
export class SaveReference implements IReturn<SaveReferenceResponse>, IPost
{
    /**
    * Patient identifier
    */
    // @ApiMember(DataType="int", Description="Patient identifier", IsRequired=true, Name="PatientId", ParameterType="body")
    public patientId: number;

    /**
    * Photo identifier
    */
    // @ApiMember(DataType="int", Description="Photo identifier", IsRequired=true, Name="PhotoId", ParameterType="body")
    public photoId: number;

    /**
    * Whether this is a reference photo or not
    */
    // @ApiMember(DataType="boolean", Description="Whether this is a reference photo or not", IsRequired=true, Name="Reference", ParameterType="body")
    public reference: boolean;

    public constructor(init?: Partial<SaveReference>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveReference'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveReferenceResponse(); }
}

// @Route("/patients/save-reference-photo", "Post")
export class SaveShowForMatching implements IReturn<SaveShowForMatchingResponse>, IPost
{
    /**
    * Patient identifier
    */
    // @ApiMember(DataType="int", Description="Patient identifier", IsRequired=true, Name="PatientId", ParameterType="body")
    public patientId: number;

    /**
    * Photo identifier
    */
    // @ApiMember(DataType="int", Description="Photo identifier", IsRequired=true, Name="PhotoId", ParameterType="body")
    public photoId: number;

    /**
    * Whether this is a reference photo or not
    */
    // @ApiMember(DataType="boolean", Description="Whether this is a reference photo or not", IsRequired=true, Name="Reference", ParameterType="body")
    public showForMatching: boolean;

    public constructor(init?: Partial<SaveShowForMatching>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveShowForMatching'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveShowForMatchingResponse(); }
}

// @Route("/patients/save-reference-photo", "Post")
export class SaveInadequateQuality implements IReturn<SaveInadequateQualityResponse>, IPost
{
    /**
    * Patient identifier
    */
    // @ApiMember(DataType="int", Description="Patient identifier", IsRequired=true, Name="PatientId", ParameterType="body")
    public patientId: number;

    /**
    * Photo identifier
    */
    // @ApiMember(DataType="int", Description="Photo identifier", IsRequired=true, Name="PhotoId", ParameterType="body")
    public photoId: number;

    /**
    * Whether this is a reference photo or not
    */
    // @ApiMember(DataType="boolean", Description="Whether this is a reference photo or not", IsRequired=true, Name="InadequateQuality", ParameterType="body")
    public inadequateQuality: boolean;

    public constructor(init?: Partial<SaveInadequateQuality>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveInadequateQuality'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveInadequateQualityResponse(); }
}

// @Route("/patients/match-batches/{StudyNumber}", "GET")
export class GetPatientMatchBatches implements IReturn<GetPatientMatchBatchesResponse>, IGet, IHasStudyNumber
{
    /**
    * The Study Number of the patient
    */
    // @ApiMember(DataType="string", Description="The Study Number of the patient", IsRequired=true, Name="Study Number", ParameterType="path")
    public studyNumber: string;

    public constructor(init?: Partial<GetPatientMatchBatches>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientMatchBatches'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientMatchBatchesResponse(); }
}

// @Route("/patients/match-batch/{StudyNumber}", "GET")
// @Route("/patients/match-batch/{StudyNumber}/{MatchBatchId}", "GET")
export class GetPatientMatchBatch implements IReturn<GetPatientMatchBatchResponse>, IGet, IHasStudyNumber
{
    /**
    * The Study Number of the patient
    */
    // @ApiMember(DataType="string", Description="The Study Number of the patient", IsRequired=true, Name="Study Number", ParameterType="path")
    public studyNumber: string;

    /**
    * The ID of the Match Batch
    */
    // @ApiMember(DataType="int", Description="The ID of the Match Batch", Name="Match Batch ID", ParameterType="path")
    public matchBatchId?: number;

    public constructor(init?: Partial<GetPatientMatchBatch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientMatchBatch'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientMatchBatchResponse(); }
}

// @Route("/patients/match-results/{StudyNumber}/{MatchId}/{Limit}/{Skip}", "GET")
export class GetPatientMatchResults implements IReturn<GetPatientMatchResultsResponse>, IGet, IHasStudyNumber
{
    /**
    * The Study Number of the patient
    */
    // @ApiMember(DataType="string", Description="The Study Number of the patient", IsRequired=true, Name="Study Number", ParameterType="path")
    public studyNumber: string;

    /**
    * The ID of the Match
    */
    // @ApiMember(DataType="int", Description="The ID of the Match", IsRequired=true, Name="Match ID", ParameterType="path")
    public matchId: number;

    /**
    * Number of results to return
    */
    // @ApiMember(DataType="int", Description="Number of results to return", IsRequired=true, Name="Limit Results", ParameterType="path")
    public limit: number;

    /**
    * Number of results to skip
    */
    // @ApiMember(DataType="int", Description="Number of results to skip", IsRequired=true, Name="Skip Results", ParameterType="path")
    public skip: number;

    public constructor(init?: Partial<GetPatientMatchResults>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientMatchResults'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientMatchResultsResponse(); }
}

// @Route("/patients/match-results/{PatientId}", "POST")
export class QueueMatchBatch implements IReturn<QueueMatchBatchResponse>, IGet, IHasPatientId
{
    /**
    * The ID of the Patient
    */
    // @ApiMember(DataType="int", Description="The ID of the Patient", IsRequired=true, Name="Patient ID", ParameterType="path")
    public patientId: number;

    /**
    * Photographs to submit
    */
    // @ApiMember(DataType="int", Description="Photographs to submit", IsRequired=true, Name="Photographs", ParameterType="path")
    public photographs: number[];

    public queueAlgorithm: QueueAlgorithm;
    public referenceChecked: boolean;
    public confirmedDiagnosisChecked: boolean;
    public undiagnosedChecked: boolean;

    public constructor(init?: Partial<QueueMatchBatch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueMatchBatch'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueueMatchBatchResponse(); }
}

// @Route("/patients/comments/{StudyNumber}", "GET")
export class GetPatientComments implements IReturn<GetPatientCommentsResponse>, IGet, IHasStudyNumber
{
    /**
    * The Study Number of the patient
    */
    // @ApiMember(DataType="string", Description="The Study Number of the patient", IsRequired=true, Name="Study Number", ParameterType="path")
    public studyNumber: string;

    public constructor(init?: Partial<GetPatientComments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientComments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientCommentsResponse(); }
}

// @Route("/patients/set-status", "Post")
export class SetStatus implements IReturn<SetStatusResponse>, IPost
{
    /**
    * The id of the patient to save
    */
    // @ApiMember(DataType="int", Description="The id of the patient to save", IsRequired=true, Name="PatientId", ParameterType="body")
    public patientId: number;

    /**
    * The status to set the patient to
    */
    // @ApiMember(DataType="object", Description="The status to set the patient to", IsRequired=true, Name="PatientStatus", ParameterType="body")
    public status: PatientStatus;

    /**
    * A comment to go along with the status
    */
    // @ApiMember(DataType="string", Description="A comment to go along with the status", Name="Comment", ParameterType="body")
    public comment: string;

    public constructor(init?: Partial<SetStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetStatusResponse(); }
}

// @Route("/patients/set-diagnosis", "Post")
export class SetDiagnosis implements IReturn<SetDiagnosisResponse>, IPost
{
    /**
    * The id of the patient to save
    */
    // @ApiMember(DataType="int", Description="The id of the patient to save", IsRequired=true, Name="PatientId", ParameterType="body")
    public patientId: number;

    /**
    * The diagnosis to set the patient to
    */
    // @ApiMember(DataType="int", Description="The diagnosis to set the patient to", IsRequired=true, Name="FaceMatchDiagnosisId", ParameterType="body")
    public faceMatchDiagnosisId: number;

    /**
    * A diagnosis note
    */
    // @ApiMember(DataType="string", Description="A diagnosis note", Name="FaceMatchDiagnosisNotes", ParameterType="body")
    public faceMatchDiagnosisNotes: string;

    public constructor(init?: Partial<SetDiagnosis>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDiagnosis'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDiagnosisResponse(); }
}

export class PersonRoleMmeGetSingleById implements IReturn<PersonRoleMmeGetSingleResponse>
{
    public id?: number;

    public constructor(init?: Partial<PersonRoleMmeGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PersonRoleMmeGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PersonRoleMmeGetSingleResponse(); }
}

export class PersonRoleMmeGetSingleByIds implements IReturn<PersonRoleMmeGetSingleResponse>
{
    public personId?: number;
    public role?: Role;
    public patientId?: number;

    public constructor(init?: Partial<PersonRoleMmeGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PersonRoleMmeGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PersonRoleMmeGetSingleResponse(); }
}

export class PersonRoleMmeGetSingleByIdsStudyNumber implements IReturn<PersonRoleMmeGetSingleResponse>
{
    public personId?: number;
    public role?: Role;
    public patientStudyNumber: string;

    public constructor(init?: Partial<PersonRoleMmeGetSingleByIdsStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PersonRoleMmeGetSingleByIdsStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PersonRoleMmeGetSingleResponse(); }
}

export class PersonRoleMmeSaveSingle implements IReturn<PersonRoleMmeSaveSingleResponse>
{
    public personRoleMme: PersonRoleMme;

    public constructor(init?: Partial<PersonRoleMmeSaveSingle>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PersonRoleMmeSaveSingle'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PersonRoleMmeSaveSingleResponse(); }
}

// @Route("/person/authenticated", "GET")
export class GetAuthenticatedPerson implements IReturn<GetAuthenticatedPersonResponse>, IGet
{

    public constructor(init?: Partial<GetAuthenticatedPerson>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAuthenticatedPerson'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAuthenticatedPersonResponse(); }
}

// @Route("/person/register/parent", "POST")
export class RegisterAsParent implements IReturn<RegisterAsParentResponse>, IPost
{
    /**
    * The person registering as a parent
    */
    // @ApiMember(DataType="object", Description="The person registering as a parent", IsRequired=true, Name="Person", ParameterType="body")
    public person: Person;

    /**
    * The password entered by the user
    */
    // @ApiMember(DataType="string", Description="The password entered by the user", IsRequired=true, Name="Password", ParameterType="body")
    public password: string;

    /**
    * Whether or not the person is registering from an invitation
    */
    // @ApiMember(DataType="boolean", Description="Whether or not the person is registering from an invitation", IsRequired=true, Name="RegisterFromInvitation", ParameterType="body")
    public registerFromInvitation: boolean;

    /**
    * The guid of the invite
    */
    // @ApiMember(DataType="string", Description="The guid of the invite", Name="InvitationGuid", ParameterType="body")
    public invitationGuid: string;

    public constructor(init?: Partial<RegisterAsParent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegisterAsParent'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegisterAsParentResponse(); }
}

// @Route("/person/register/doctor", "POST")
export class RegisterAsDoctor implements IReturn<RegisterAsDoctorResponse>, IPost
{
    /**
    * The person registering as a doctor
    */
    // @ApiMember(DataType="object", Description="The person registering as a doctor", IsRequired=true, Name="Person", ParameterType="body")
    public person: Person;

    /**
    * The password entered by the user
    */
    // @ApiMember(DataType="string", Description="The password entered by the user", IsRequired=true, Name="Password", ParameterType="body")
    public password: string;

    /**
    * The guid of the invite
    */
    // @ApiMember(DataType="string", Description="The guid of the invite", Name="InvitationGuid", ParameterType="body")
    public invitationGuid: string;

    public constructor(init?: Partial<RegisterAsDoctor>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegisterAsDoctor'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegisterAsDoctorResponse(); }
}

// @Route("/people")
// @Route("/people/{Number}")
// @Route("/people/{Number}/{Page}")
export class LoadPeople implements IReturn<LoadPeopleResponse>, IPost, IGet
{
    public number?: number;
    public page?: number;
    public tableFilter: TableFilter[];
    public tableSort: TableSort[];

    public constructor(init?: Partial<LoadPeople>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LoadPeople'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LoadPeopleResponse(); }
}

// @Route("/export/patient")
export class ExportPatients implements IReturn<LoadPeopleResponse>, IGet
{
    public startDate: string;
    public endDate: string;
    public tableFilter: string;

    public constructor(init?: Partial<ExportPatients>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportPatients'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LoadPeopleResponse(); }
}

// @Route("/export/people")
export class ExportPeople implements IReturn<LoadPeopleResponse>, IGet
{
    public startDate: string;
    public endDate: string;
    public tableFilter: string;

    public constructor(init?: Partial<ExportPeople>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportPeople'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LoadPeopleResponse(); }
}

// @Route("/impersonate", "GET")
export class ImpersonatePerson implements IReturnVoid, IGet
{
    public personId?: number;
    public continue: string;

    public constructor(init?: Partial<ImpersonatePerson>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImpersonatePerson'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/person/by-id/{Id}", "GET")
export class GetPersonById implements IReturn<GetPersonByIdResponse>, IGet
{
    /**
    * The id of the person
    */
    // @ApiMember(DataType="int", Description="The id of the person", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetPersonById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonByIdResponse(); }
}

// @Route("/person/delete-by-id/{Id}", "GET")
export class DeletePersonById implements IReturn<DeletePersonByIdResponse>, IGet
{
    /**
    * The id of the person
    */
    // @ApiMember(DataType="int", Description="The id of the person", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<DeletePersonById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeletePersonById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DeletePersonByIdResponse(); }
}

// @Route("/person/profile/save", "POST")
export class SaveProfile implements IReturn<SaveProfileResponse>, IPost
{
    /**
    * The person saving their profile
    */
    // @ApiMember(DataType="object", Description="The person saving their profile", IsRequired=true, Name="Person", ParameterType="body")
    public person: Person;

    public constructor(init?: Partial<SaveProfile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveProfile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveProfileResponse(); }
}

// @Route("/people/role/{RoleId}", "GET")
export class GetPeopleByRole implements IReturn<GetPeopleByRoleResponse>, IGet
{
    /**
    * The role id of the people to retrieve
    */
    // @ApiMember(DataType="int", Description="The role id of the people to retrieve", IsRequired=true, Name="RoleId", ParameterType="path")
    public roleId: number;

    public constructor(init?: Partial<GetPeopleByRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPeopleByRole'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPeopleByRoleResponse(); }
}

// @Route("/email/verification/by-guid", "POST")
export class VerifyEmailByGuid implements IReturn<VerifyEmailByGuidResponse>, IPost
{
    /**
    * The GUID of the email verification.
    */
    // @ApiMember(DataType="string", Description="The GUID of the email verification.", IsRequired=true, Name="GUID", ParameterType="body")
    public guid: string;

    public constructor(init?: Partial<VerifyEmailByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VerifyEmailByGuid'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VerifyEmailByGuidResponse(); }
}

// @Route("/person/email-verification", "POST")
export class ResendEmailVerification implements IReturn<ResendEmailVerificationResponse>, IPost
{

    public constructor(init?: Partial<ResendEmailVerification>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResendEmailVerification'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResendEmailVerificationResponse(); }
}

// @Route("/auth/{provider}/reset", "POST")
export class ResetPasswordEmail implements IReturn<ResponseStatus>, IPost
{
    /**
    * The email address of the account whose password is being reset
    */
    // @ApiMember(DataType="string", Description="The email address of the account whose password is being reset", IsRequired=true, Name="Email", ParameterType="body")
    public email: string;

    public constructor(init?: Partial<ResetPasswordEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResetPasswordEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/personToken/by-id/{Id}", "GET")
export class GetPersonTokenById implements IReturn<GetPersonTokenByIdResponse>, IGet
{
    /**
    * The Id of the user requesting the token
    */
    // @ApiMember(DataType="int", Description="The Id of the user requesting the token", IsRequired=true, Name="personId", ParameterType="path")
    public personId: number;

    public constructor(init?: Partial<GetPersonTokenById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPersonTokenById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPersonTokenByIdResponse(); }
}

// @Route("/auth/update", "POST")
export class PostUpdatePassword implements IReturn<PostUpdatePasswordResponse>, IPost
{
    /**
    * The Id of the user requesting the token
    */
    // @ApiMember(DataType="int", Description="The Id of the user requesting the token", IsRequired=true, Name="personId", ParameterType="body")
    public personId: number;

    /**
    * The new password of the user requesting the reset
    */
    // @ApiMember(DataType="string", Description="The new password of the user requesting the reset", IsRequired=true, Name="password", ParameterType="body")
    public password: string;

    /**
    * The verification token for the user requesting the reset
    */
    // @ApiMember(DataType="string", Description="The verification token for the user requesting the reset", IsRequired=true, Name="token", ParameterType="body")
    public token: string;

    public constructor(init?: Partial<PostUpdatePassword>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUpdatePassword'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostUpdatePasswordResponse(); }
}

// @Route("/people/{email}", "GET")
export class CheckAccoutnExists implements IReturn<ResponseStatus>, IGet
{
    /**
    * The email to be checked
    */
    // @ApiMember(DataType="string", Description="The email to be checked", IsRequired=true, Name="email", ParameterType="path")
    public email: string;

    public constructor(init?: Partial<CheckAccoutnExists>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CheckAccoutnExists'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/bulk-reset", "GET")
export class BulkResetPasswordEmail implements IReturn<ResponseStatus>, IPost
{

    public constructor(init?: Partial<BulkResetPasswordEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BulkResetPasswordEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/doctors", "GET")
export class LoadPublicDoctors implements IReturn<LoadPublicDoctorsResponse>, IGet
{

    public constructor(init?: Partial<LoadPublicDoctors>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LoadPublicDoctors'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LoadPublicDoctorsResponse(); }
}

export class GetReferencePatientByStudyNumber implements IReturn<GetReferencePatientByStudyNumberResponse>, IGet, IHasStudyNumber
{
    /**
    * The study number of the patient
    */
    // @ApiMember(DataType="string", Description="The study number of the patient", IsRequired=true, Name="Study Number", ParameterType="path")
    public studyNumber: string;

    public constructor(init?: Partial<GetReferencePatientByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReferencePatientByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetReferencePatientByStudyNumberResponse(); }
}

// @Route("/reference-patients/save-reference-photo", "Post")
export class SaveReferenceShowForMatching implements IReturn<SaveReferenceShowForMatchingResponse>, IPost
{
    /**
    * Patient identifier
    */
    // @ApiMember(DataType="int", Description="Patient identifier", IsRequired=true, Name="PatientId", ParameterType="body")
    public patientId: number;

    /**
    * Photo identifier
    */
    // @ApiMember(DataType="int", Description="Photo identifier", IsRequired=true, Name="PhotoId", ParameterType="body")
    public photoId: number;

    /**
    * Whether this is a reference photo or not
    */
    // @ApiMember(DataType="boolean", Description="Whether this is a reference photo or not", IsRequired=true, Name="Reference", ParameterType="body")
    public showForMatching: boolean;

    public constructor(init?: Partial<SaveReferenceShowForMatching>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveReferenceShowForMatching'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveReferenceShowForMatchingResponse(); }
}

// @Route("/reference-patients/save-reference-photo", "Post")
export class SaveReferenceInadequateQuality implements IReturn<SaveReferenceInadequateQualityResponse>, IPost
{
    /**
    * Patient identifier
    */
    // @ApiMember(DataType="int", Description="Patient identifier", IsRequired=true, Name="PatientId", ParameterType="body")
    public patientId: number;

    /**
    * Photo identifier
    */
    // @ApiMember(DataType="int", Description="Photo identifier", IsRequired=true, Name="PhotoId", ParameterType="body")
    public photoId: number;

    /**
    * Whether this is a reference photo or not
    */
    // @ApiMember(DataType="boolean", Description="Whether this is a reference photo or not", IsRequired=true, Name="InadequateQuality", ParameterType="body")
    public inadequateQuality: boolean;

    public constructor(init?: Partial<SaveReferenceInadequateQuality>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveReferenceInadequateQuality'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveReferenceInadequateQualityResponse(); }
}

// @Route("/generate-template", "POST")
export class GenerateTemplate implements IReturn<GenerateTemplateResponse>, IPost
{
    /**
    * The Id of the template.
    */
    // @ApiMember(DataType="int", Description="The Id of the template.", IsRequired=true, Name="Id", ParameterType="body")
    public id: TemplateType;

    /**
    * The TemplateData for the template.
    */
    // @ApiMember(DataType="dictionary", Description="The TemplateData for the template.", IsRequired=true, Name="TemplateData", ParameterType="body")
    public templateData: { [index: string]: Object; };

    public constructor(init?: Partial<GenerateTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GenerateTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GenerateTemplateResponse(); }
}

// @Route("/get-all-templates", "GET")
export class GetAllTemplates implements IReturn<GetAllTemplatesResponse>, IGet
{

    public constructor(init?: Partial<GetAllTemplates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllTemplates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAllTemplatesResponse(); }
}

// @Route("/get-customisable-templates", "GET")
export class GetCustomisableTemplates implements IReturn<GetCustomisableTemplatesResponse>, IGet
{

    public constructor(init?: Partial<GetCustomisableTemplates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomisableTemplates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCustomisableTemplatesResponse(); }
}

// @Route("/send-generated-template", "POST")
export class SendGeneratedTemplate implements IReturn<SendGeneratedTemplateResponse>, IPost
{
    public mail: Mail;
    public patientId?: number;
    public personId?: number;

    public constructor(init?: Partial<SendGeneratedTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendGeneratedTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendGeneratedTemplateResponse(); }
}

// @Route("/temporary-file/upload", "POST")
export class UploadFile implements IReturn<UploadFileResponse>
{
    public json: boolean;

    public constructor(init?: Partial<UploadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadFileResponse(); }
}

// @Route("/temporary-file/image/{Guid}", "GET")
export class GetTemporaryImage implements IReturn<Blob>, IGet
{
    /**
    * The Guid of the file
    */
    // @ApiMember(DataType="integer", Description="The Guid of the file", Format="int32", IsRequired=true, Name="File Guid", ParameterType="path")
    public guid: string;

    /**
    * The width at which to return the file.
    */
    // @ApiMember(DataType="integer", Description="The width at which to return the file.", Format="int32", IsRequired=true, Name="Width", ParameterType="query")
    public width: number;

    /**
    * The height at which to return the file
    */
    // @ApiMember(DataType="integer", Description="The height at which to return the file", Format="int32", IsRequired=true, Name="Height", ParameterType="query")
    public height: number;

    public constructor(init?: Partial<GetTemporaryImage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTemporaryImage'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/temporary-file/file/{Guid}", "GET")
export class GetTemporaryFile implements IReturn<Blob>, IGet
{
    /**
    * The Guid of the file
    */
    // @ApiMember(DataType="integer", Description="The Guid of the file", Format="int32", IsRequired=true, Name="File Guid", ParameterType="path")
    public guid: string;

    public constructor(init?: Partial<GetTemporaryFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTemporaryFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

/**
* Sign Up
*/
// @Route("/register")
// @Api(Description="Sign Up")
// @DataContract
export class Register implements IReturn<RegisterResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public firstName: string;

    // @DataMember(Order=3)
    public lastName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public email: string;

    // @DataMember(Order=6)
    public password: string;

    // @DataMember(Order=7)
    public confirmPassword: string;

    // @DataMember(Order=8)
    public autoLogin?: boolean;

    // @DataMember(Order=10)
    public errorView: string;

    // @DataMember(Order=11)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Register>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Register'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegisterResponse(); }
}

/**
* Sign In
*/
// @Route("/auth")
// @Route("/auth/{provider}")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    /**
    * AuthProvider, e.g. credentials
    */
    // @DataMember(Order=1)
    // @ApiMember(Description="AuthProvider, e.g. credentials")
    public provider: string;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public oauth_token: string;

    // @DataMember(Order=4)
    public oauth_verifier: string;

    // @DataMember(Order=5)
    public userName: string;

    // @DataMember(Order=6)
    public password: string;

    // @DataMember(Order=7)
    public rememberMe?: boolean;

    // @DataMember(Order=9)
    public errorView: string;

    // @DataMember(Order=10)
    public nonce: string;

    // @DataMember(Order=11)
    public uri: string;

    // @DataMember(Order=12)
    public response: string;

    // @DataMember(Order=13)
    public qop: string;

    // @DataMember(Order=14)
    public nc: string;

    // @DataMember(Order=15)
    public cnonce: string;

    // @DataMember(Order=17)
    public accessToken: string;

    // @DataMember(Order=18)
    public accessTokenSecret: string;

    // @DataMember(Order=19)
    public scope: string;

    // @DataMember(Order=20)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiKeys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiKeysResponse(); }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegenerateApiKeys'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegenerateApiKeysResponse(); }
}

